import { detect } from 'detect-browser';

export default function isChrome(): boolean {
  const browser = detect();
  return browser?.name === 'chrome';
}
